import * as React from 'react';
import { categoryStyleFor } from '../config';
import { formatFullTimestamp, formatRelativeTime } from '../format';
import type { ActivityItem as ActivityItemType, Audience } from '../types';

type ActivityItemProps = {
  item: ActivityItemType;
  onOpen: (item: ActivityItemType) => void;
  className?: string;
  audience?: Audience | null;
};

export function ActivityItem({ item, onOpen, className, audience = null }: ActivityItemProps) {
  const unread = !item.read_at;
  const { icon, tone } = categoryStyleFor(item.kind, audience);
  const relative = formatRelativeTime(item.occurred_at);
  const classes = ['activity-item', unread ? 'is-unread' : null, className].filter(Boolean).join(' ');

  return (
    <button type="button" className={classes} onClick={() => onOpen(item)}>
      <span className={`activity-item__icon activity-item__icon--${tone}`} aria-hidden="true">
        <i className={`fas ${icon}`} />
      </span>
      <span className="activity-item__body">
        <strong className="activity-item__title">{item.title}</strong>
        {item.body ? <span className="activity-item__excerpt">{item.body}</span> : null}
      </span>
      <span className="activity-item__meta">
        {unread ? <span className="activity-item__dot" aria-hidden="true" /> : null}
        {relative && item.occurred_at ? (
          <time
            className="activity-item__time"
            dateTime={item.occurred_at}
            title={formatFullTimestamp(item.occurred_at)}
          >
            {relative}
          </time>
        ) : null}
      </span>
      <span className="activity-item__arrow" aria-hidden="true">
        <i className="fas fa-arrow-right" />
      </span>
      {unread ? <span className="visually-hidden">Unread</span> : null}
    </button>
  );
}
